.button {
  align-items: center;
  background: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 6px;
  color: var(--color-foreground, #18181b);
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  padding: 8px 14px;
  transition:
    background-color 120ms ease,
    border-color 120ms ease;
}

.button:hover {
  background-color: var(--color-muted, #f4f4f5);
  border-color: var(--color-ring, #71717a);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.button-icon {
  color: var(--color-muted-foreground, #71717a);
  display: inline-flex;
}

.backdrop {
  align-items: center;
  background-color: rgb(0 0 0 / 50%);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  z-index: 50;
}

.modal {
  background: var(--color-card, #fff);
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 10%);
  max-width: 480px;
  padding: 24px;
  width: 100%;
}

.modal-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.modal-title {
  color: var(--color-foreground, #18181b);
  font-size: 16px;
  font-weight: 600;
}

.modal-close {
  background: transparent;
  border: 0;
  color: var(--color-muted-foreground, #71717a);
  cursor: pointer;
  font-size: 20px;
  padding: 4px;
}
